var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"-mt-32"},[_c('calendar-day'),_vm._v(" "),_c('calendar-week')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }